import requestForm from './requestForm.hbs';
import contentBlockService from '../contentBlock/contentBlockService/contentBlockService';

class RequestFormController {
    constructor(container) {
        this.state = {
            content: '',
            metaDataOptions: {},
        };

        this.container = container;
        this.template = requestForm;

        this.renderForm = this.renderForm.bind(this);
        this.getUserMetaData = this.getUserMetaData.bind(this);

        Collaterate.User.getUserMetadataOptions()
            .then(this.getUserMetaData)
            .then( () => { this.getContentBlock(); })
            .then( () => { this.renderForm(); })
        return;
    }

    getUserMetaData (userMetadataOptions) {
        this.state.metaDataOptions = userMetadataOptions.map(items => ({...items, value: ''}));
    }

    getContentBlock() {
        return contentBlockService.getBlock('request-form-message')
            .then((content) => {
                this.state.content = content;
            })
            .then(this.renderForm);
    }

    renderForm() {
        this.container.innerHTML = this.template(this.state);
    }
}

export default RequestFormController;